import { isInventoryQuestion } from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { getQuestionsCollection } from '../pureSelectors';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getHasInventoryQuestions = (state: CheckoutState) =>
    Object.values(getQuestionsCollection(state)).some((question) =>
        isInventoryQuestion(question.choices),
    );
